import type { FaireProductEntity } from "../../entity_types/product";

export const p_2h9aqyn68v: FaireProductEntity = {
  token: "p_2h9aqyn68v",
  type: "product",
  name: "1CT Oval cut Vintage  Moissanite Ring 925 Sterling Silver",
  brandToken: "b_mpb8yp79mh",
  brandName: "GEMPARA",
  imageUrl:
    "https://cdn.faire.com/fastly/0400b0b8b417d7a3934f77136075b8c6547222044fae1d804e056fb52dd0138f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7f03c96d4e4d6ef5fd9ae71fdbb602304c87b91964b17c64537408752b5f6366.jpeg",
    "https://cdn.faire.com/fastly/f258a6acd5b560f8d59958cea7b6f7e982a876fc3cc58ab46b7ca243c28e956e.jpeg",
    "https://cdn.faire.com/fastly/b8a1473e30fa7f74b2b671a47eab76ade73cb6947e667d8b74e0cde1f97b9ce3.jpeg",
  ],
  priceDollars: 55.41,
  description:
    "\nProduct Details\n\nMain Gemstone: 1CT Oval cut Moissanite (6.0 x 4.0 mm)\n\nSide Stones: 0.21CT  Moissanites\n\nTotal Stones : 13\n\nNet Weight : 1.03 grams\n\nTimeless elegance meets modern craftsmanship in this vintage-inspired ring. At its heart, a 1CT oval-cut lab Moissanite radiates brilliance, framed by 12 shimmering lab-grown Moissanites that add depth and dimension. Thoughtfully designed with intricate detailing, this piece captures the charm of old-world romance while offering contemporary wearability. With a lightweight yet luxurious feel at 1.03 grams, it’s the perfect statement of refined beauty—whether as a self-gift or a treasured keepsake.\n",
  tags: [],
  msrpDollars: 110.83,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:58:54.591Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
